import React from 'react';
import { Input, Form, Row, Col, Button } from 'antd';
import { connect } from 'dva';
import styles from './SearchForm.less';

const FormItem = Form.Item;

@connect(({ operationChargeItemPublishChargeItemSteps }) => ({
  searchParams: operationChargeItemPublishChargeItemSteps.searchParams,
  refreshFlag: operationChargeItemPublishChargeItemSteps.refreshFlag,
}))
@Form.create()
export default class SearchForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.search = this.search.bind(this);
    this.handleFormReset = this.handleFormReset.bind(this);
  }

  componentDidMount() {
    this.search();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.refreshFlag === false && nextProps.refreshFlag === true) {
      this.search();
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/savePagination',
      pagination: { current: 1 },
    });

    this.props.dispatch({ type: 'operationChargeItemPublishChargeItemSteps/toggleRefreshFlag' });
  }

  handleFormReset() {
    this.props.form.resetFields();

    this.search();
  }

  search() {
    const values = this.props.form.getFieldsValue();
    this.props.dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/saveSearchForm',
      searchParams: values,
    });

    if (this.props.onSearch) {
      this.props.onSearch(values);
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form className={styles.root} onSubmit={this.handleSubmit} layout="inline">
        <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
          <Col md={12} sm={24} />

          <Col md={12} sm={24} className="search-wrap">
            <FormItem>{getFieldDecorator('key')(<Input placeholder="商品名/商品号" />)}</FormItem>
            <Button type="primary" htmlType="submit">
              查询
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step1/SearchForm.js